var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"questionFrame",staticClass:"questions"},[_c('image-vertical',{ref:"questionContent",staticClass:"questions__image",attrs:{"pageNumber":_vm.$route.query.page}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }